import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card';
import styles from './styles.scoped.css';
import IconFilterWithCircle from '../../icons/IconFilterWithCircle';
import Button from '../Button';
import classNames from '../../../utils/classNames';

export default function Filter({ className, fields, handleReset, style }) {
  return (
    <Card className={styles.filter} style={style}>
      <div className={styles.header}>
        <div>
          <IconFilterWithCircle />
          <h4>Filter by:</h4>
        </div>
        <div>
          <Button onClick={handleReset} outlined style="default">
            Reset Filter
          </Button>
        </div>
      </div>
      <br />
      <div className={className ? className : 'fields'}>
        {fields.map((field) => (
          <div
            className={classNames(
              styles.field,
              field.disabled ? styles.disabled : ''
            )}
            key={field.label}
          >
            <label>{field.label}</label>
            {field.component}
          </div>
        ))}
      </div>
    </Card>
  );
}

Filter.propTypes = {
  className: PropTypes.string,
  fields: PropTypes.array,
  handleReset: PropTypes.func,
  style: PropTypes.object,
};

Filter.defaultProps = {
  className: '',
  fields: [],
  handleReset: () => {},
  style: {},
};
